import { FileContent } from 'components/common/types';
import { FRAME_LIST_LABELS } from 'utils/frameList';

export interface FrameTable {
  headers: string[];
  rows: Map<string, string>[];
}

interface ExtractOptions {
  requiredHeaders?: string[];
  missingHeaderMessage?: (label: string) => string;
}

export const FrameTableAdapter = {
  fromRows: (rows: string[][]): FrameTable => {
    const [headers = [], ...dataRows] = rows;

    return {
      headers,
      rows: dataRows.map((row) => new Map(headers.map((label, index) => [label, row[index]]))),
    };
  },

  fromRecords: (rows: Record<string, string>[]): FrameTable => ({
    headers: [...new Set(rows.flatMap((row) => Object.keys(row)))],
    rows: rows.map((row) => new Map(Object.entries(row))),
  }),
};

const getInclude = (row: Map<string, string>): boolean => {
  const value = row.get(FRAME_LIST_LABELS.include);

  return value === undefined || String(value).toLowerCase() !== 'false';
};

export const extractFrameCodes = (
  table: FrameTable,
  marketId = '',
  isReseller = false,
  { requiredHeaders = [FRAME_LIST_LABELS.frameId], missingHeaderMessage }: ExtractOptions = {},
): FileContent[] => {
  const missingHeader = requiredHeaders.find((label) => !table.headers.includes(label));

  if (missingHeader) {
    throw new Error(
      missingHeaderMessage?.(missingHeader) ?? `The file must contain a "${missingHeader}" header column`,
    );
  }

  return table.rows.reduce((acc: FileContent[], row) => {
    const frameId = row.get(FRAME_LIST_LABELS.frameId);
    if (!frameId) return acc;

    const mediaOwner = row.get(FRAME_LIST_LABELS.mediaOwner);

    acc.push({
      include: getInclude(row),
      code: frameId,
      name: frameId,
      mediaOwner: isReseller && mediaOwner ? mediaOwner : marketId,
    });

    return acc;
  }, []);
};
